<template>
	<div class="filled-content">
		<v-toolbar app flat dark color="primary">
			<v-btn icon @click="gotoOverview()">
				<v-icon>arrow_back</v-icon>
			</v-btn>
			<v-toolbar-title>E-finder Toevoegen</v-toolbar-title>
			<v-btn icon></v-btn>
		</v-toolbar>

		<v-content class="uf-form">
			<v-list two-line class="ma-0 pa-0">
				<v-list-tile two-line avatar class="e-connectz_list-tile">
					<v-list-tile-avatar>
						<strong>1</strong>
					</v-list-tile-avatar>
					<v-list-tile-content>
						<v-list-tile-title class="font-weight-medium">Stap 1 - Identificeren</v-list-tile-title>
						<v-list-tile-sub-title>Welke E-finder wil je toevoegen?</v-list-tile-sub-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
			<v-container class="item-group">
				<img class="mt-2 mb-4" src="@/assets/images/e-finder-code.jpg" alt="Kijk op de zijkant van de E-finder. Daar vindt je de unieke code van jouw E-finder." width="100%">
				<p class="mb-4">Kijk op de zijkant van je E-finder. Daar vindt je een 6 cijferige unieke code. Vul deze hieronder in.</p>
				<form @submit.prevent="submit" class="mt-5">

					<v-text-field
						v-model="code"
						label="Code"
						placeholder="XXXXXX"
						:counter="6"
						:maxlength="6"
						:error-messages="errorMessage"
						:loading="loading"
						@input="errorMessage = ''"
						required
						class="mb-4"
					></v-text-field>

					<v-dialog v-model="showDialog" max-width="360px">
						<template v-slot:activator="{on}">
							<v-btn type="submit" block dark depressed large color="primary" v-on="on">Nummer controleren</v-btn>
						</template>

						<v-card color="primary" class="white--text" v-if="state === 'valid'">
							<v-card-text class="text-xs-center">
								<h2 class="mb-4">Mooi! Dit is een geldige code.</h2>
								<h3 class="mb-4">Weet je zeker dat dit de juiste code is van jouw E-finder?</h3>
								<p class="mb-0">Je hebt het volgende ingetikt:</p>
								<h1 v-text="code || '-'"></h1>
							</v-card-text>
							<v-card-actions>
								<v-btn @click="retry()" class="caption" block depressed >Opnieuw invoeren</v-btn>
								<v-btn @click="nextStep()" class="green--text caption" block depressed>Ja, dit klopt</v-btn>
							</v-card-actions>
						</v-card>

						<v-card color="primary" class="white--text" v-else-if="state === 'invalid'">
							<v-card-text class="text-xs-center">
								<h2 class="mb-4">Helaas, deze code is ongeldig</h2>
								<h3 class="mb-4">Weet je zeker dat dit de juiste Code is van jouw E-finder?</h3>
								<p class="mb-0">Je hebt het volgende ingetikt:</p>
								<h1 v-text="code || '-'"></h1>
							</v-card-text>
							<v-card-actions>
								<v-btn class="caption" block depressed @click="showDialog = false">Opnieuw invoeren</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

				</form>
			</v-container>
		</v-content>


	</div>
</template>

<script>
  export default {
    data() {
      return {
        showDialog: false,
        code: '',
        errorMessage: '',
		loading: false,
		valid: false,
		state: 'idle'
      };
    },
    watch: {
      code(value) {
        this.$nextTick(() => {
          this.code = value.replace(/[^0-9A-Fa-f]+/gi, '')
            .toUpperCase();
        });
      }
    },
    methods: {
      gotoOverview(fallback) {
        this.$router.replace({name: 'devices.add'});
      },
      async submit() {
        this.state = 'loading';
        try {
          const response = await this.$http.get(`/account/devices/find/${this.code}`,
            {
              headers: { Authorization: `Bearer ${this.$store.state.auth.token}` }
            });
        } catch (error) {
          return this.state = 'invalid';
        }

        return this.state = 'valid';
      },
      retry(){
        this.state = 'idle';
        this.showDialog = false;
	  },
      nextStep() {
        this.state = 'idle';
        this.showDialog = false;
        this.$router.push({ name: 'devices.subscription', params: { slug: this.code }});
	  }
    }
  };
</script>

<style lang="stylus">
	.uf-form
		position: relative
		background-color: #f2f2f2

	.item-group
		background-color: #fff
		border-top: solid 1px #ddd
		border-bottom: solid 1px #ddd
</style>
